import React, {useEffect, useRef, useState} from 'react';
import classnames from "classnames";

import {Button} from './Button';
import {Audio} from './Audio';



import {
    DOMAIN_ACTION, ELEMENT_ACTION,
    getStations,
    LOADING,
    NOADV_ACTION,
    Player,
    PlayerContext,
    PlayerContextDispatch,
    PlayerInitContext,
    PlayerReducerContext,
    Size,
    SIZE_ACTION,
    STATUS_ACTION,
    STREAMS_ACTION
} from "./PlayerReducer";

import {Station, Stations} from "./Station";

import './index.scss';
import {deleteCookie, getCookie} from "./utils";
import {MESSAGEJUMP, MESSAGELOCATION, MessageType} from "./PlayerReducerSetting";


export default (props: {
    velikost: Size
}): JSX.Element => {

    let [radiaLoaded, setRadiaLoaded] = useState(false);
    let element = useRef<HTMLDivElement|null>(null);
    const [player, dispatch] = React.useReducer(PlayerReducerContext, {} as Player, PlayerInitContext());


    useEffect(() => {


        window.addEventListener('skok', ()=>{
            window.open(window.location +'', '_blank')
        })
        document.addEventListener('skok', (ev)=>{
            window.open(window.location +'', '_blank')
        });

        window.addEventListener('message', (ev)=>{
            try {

                const parsed = JSON.parse(ev.data) as MessageType
                if (parsed) {
                    if ( parsed.type === MESSAGELOCATION) {
                        dispatch({
                            type: DOMAIN_ACTION,
                            payload: parsed.domain
                        })
                    }
                    if (parsed.type == MESSAGEJUMP)
                    {
                        window.open(window.location +'', '_blank')
                    }
                }
            }
            catch (e)
            {

            }
        })

        if (document.referrer)
        {

            const match = document.referrer.match(/https?:\/\/([^\/]+)/);
            if (match) {
               // console.log(document.domain);
               // console.log(match[1]);
               // document.domain = match[1];
                dispatch({
                    type: DOMAIN_ACTION,
                    payload: match[1]
                })
            }
        }

        window.parent.postMessage('radiaczplayerload', "*")
        dispatch({
            type: SIZE_ACTION,
            payload: props.velikost
        })

        let hostname = window.location.hostname || 'radia.cz';
        if (window.location !== window.parent.location)
        {
            const matched = document.referrer.match(/https?:\/\/([^/]+)/);
            if (matched)
            {
                hostname = matched[1];
            }
        }

        fetch(`https://radia.cz/data/prehravac/${hostname}.json`).then(data => data.json()).then(data => {

            dispatch({
                type: STREAMS_ACTION,
                payload: getStations(data)
            });

            setRadiaLoaded(true);
            /*
            if (getCookie('puuidautoplay') === '1')
            {

                dispatch({
                    type: NOADV_ACTION
                });
            }
            /*
            if (getCookie('puuidautoplay') === '1')
            {
                dispatch({
                    type: NOADV_ACTION
                });

                deleteCookie('puuidautoplay');

                const browser = detect();

                if (browser?.name == 'chrome') {
                    dispatch({
                        type: STATUS_ACTION,
                        payload: LOADING
                    });
                }
            }

             */
            if (element.current) {
                dispatch({
                    type: ELEMENT_ACTION,
                    payload: element.current
                })
            }
        }).catch(e => {
        })

    }, []);

    const classes = {
        radiacz: radiaLoaded,
        [`radiacz-${props.velikost}`]: radiaLoaded
    }
    return (
        <PlayerContext.Provider value={player}>
            <PlayerContextDispatch.Provider value={dispatch}>
                <div ref={element} className={classnames(classes)} style={{display: 'none'}}>
                    <div className={`radiacz-cplay`}>
                        <Button/>
                    </div>
                    <div className="radiacz-top">
                        Pusťte si své <strong>oblíbené radio</strong>
                    </div>
                    <Station/>
                    <span className={'radiacz-hr'}/>
                    <Audio/>
                    <div className={'radiacz-over'}/>
                    <Stations/>
                    <div className={'radiacz-powered'}>
                        <a href={'https://radia.cz'} target={'_blank'}>powered by <span>Radia.cz</span></a>
                    </div>
                </div>
            </PlayerContextDispatch.Provider>
        </PlayerContext.Provider>
    );
}
